import styled from 'styled-components/native';

export default styled.View`
  padding: 25px 0 0;
  ${({ theme }) =>
    !theme.media.tabletLandscape &&
    `border-bottom-width: 1px;
  border-bottom-color: ${theme.orderDetailsHeader.border};`}
`;
